const ArticlesFilter = function () {
  let url = window.location.href;
  const slug = '/blogs/articles';
  const articleSelect = document.getElementById('BlogTagFilter');

  if (url.includes(slug) && articleSelect) {
    if (typeof (articleSelect) !== 'undefined') {
      articleSelect.addEventListener('change', function (e) {
        const val = e.target.value;
        window.location.href = val;
      });
    }
  }
}

export default ArticlesFilter;